var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoteski(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 287,
    height: 75,
    viewBox: "0 0 287 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_13)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 67,
    height: 72,
    fill: "#753D99",
    stroke: "#AD83C8",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.458 57H108.042L92.7896 30.5165H92.5934C92.6261 31.3339 92.6588 32.1676 92.6915 33.0177C92.7242 33.8351 92.7569 34.6689 92.7896 35.519C92.855 36.3363 92.904 37.1701 92.9367 38.0202C92.9694 38.8376 93.0021 39.6713 93.0348 40.5214V57H86.4139V21.983H95.7812L110.985 48.2212H111.132C111.099 47.4038 111.066 46.6028 111.034 45.8181C111.001 45.0007 110.968 44.1997 110.936 43.415C110.936 42.5976 110.919 41.7965 110.887 41.0118C110.854 40.1944 110.821 39.377 110.789 38.5597V21.983H117.458V57ZM152.499 43.5621C152.499 45.7854 152.188 47.7635 151.567 49.4963C150.979 51.2292 150.112 52.7005 148.968 53.9103C147.856 55.0873 146.499 55.9864 144.897 56.6077C143.295 57.1962 141.48 57.4904 139.453 57.4904C137.59 57.4904 135.857 57.1962 134.255 56.6077C132.685 55.9864 131.328 55.0873 130.184 53.9103C129.04 52.7005 128.141 51.2292 127.487 49.4963C126.865 47.7635 126.555 45.7854 126.555 43.5621C126.555 40.5868 127.078 38.0856 128.124 36.0584C129.171 33.9986 130.675 32.4292 132.636 31.3503C134.598 30.2713 136.919 29.7318 139.6 29.7318C142.118 29.7318 144.341 30.2713 146.27 31.3503C148.199 32.4292 149.72 33.9986 150.831 36.0584C151.943 38.0856 152.499 40.5868 152.499 43.5621ZM134.009 43.5621C134.009 45.3277 134.189 46.8153 134.549 48.025C134.941 49.2021 135.546 50.1012 136.364 50.7224C137.181 51.311 138.244 51.6052 139.551 51.6052C140.859 51.6052 141.905 51.311 142.69 50.7224C143.508 50.1012 144.096 49.2021 144.456 48.025C144.848 46.8153 145.044 45.3277 145.044 43.5621C145.044 41.7965 144.848 40.3252 144.456 39.1482C144.096 37.9711 143.508 37.0883 142.69 36.4998C141.873 35.9113 140.81 35.617 139.502 35.617C137.573 35.617 136.167 36.2873 135.285 37.6278C134.435 38.9357 134.009 40.9137 134.009 43.5621ZM172.27 51.6543C173.088 51.6543 173.872 51.5725 174.624 51.409C175.376 51.2456 176.128 51.0494 176.88 50.8205V56.2643C176.096 56.5913 175.115 56.8692 173.938 57.0981C172.793 57.3597 171.535 57.4904 170.161 57.4904C168.559 57.4904 167.121 57.2289 165.846 56.7057C164.603 56.1826 163.606 55.2835 162.854 54.0083C162.135 52.7005 161.775 50.9023 161.775 48.6136V35.7151H158.293V32.6254L162.314 30.1732L164.423 24.5332H169.082V30.2223H176.586V35.7151H169.082V48.6136C169.082 49.6271 169.377 50.3955 169.965 50.9186C170.554 51.409 171.322 51.6543 172.27 51.6543ZM195.742 29.7318C198.227 29.7318 200.352 30.2059 202.118 31.1541C203.916 32.1023 205.306 33.4755 206.287 35.2737C207.267 37.072 207.758 39.279 207.758 41.8946V45.4257H190.495C190.56 47.4856 191.165 49.104 192.309 50.281C193.486 51.4581 195.105 52.0466 197.164 52.0466C198.897 52.0466 200.467 51.8831 201.873 51.5562C203.279 51.1965 204.733 50.657 206.237 49.9377V55.5777C204.93 56.2317 203.54 56.7057 202.069 57C200.63 57.327 198.881 57.4904 196.821 57.4904C194.14 57.4904 191.77 57 189.71 56.0191C187.65 55.0056 186.032 53.4852 184.855 51.4581C183.677 49.431 183.089 46.8807 183.089 43.8073C183.089 40.6685 183.612 38.0692 184.658 36.0094C185.737 33.9169 187.225 32.3475 189.121 31.3012C191.018 30.255 193.225 29.7318 195.742 29.7318ZM195.791 34.9304C194.385 34.9304 193.208 35.3882 192.26 36.3037C191.345 37.2191 190.805 38.6414 190.642 40.5704H200.892C200.892 39.4915 200.696 38.527 200.303 37.6769C199.944 36.8268 199.388 36.1565 198.636 35.6661C197.884 35.1757 196.936 34.9304 195.791 34.9304ZM234.821 49.055C234.821 50.8532 234.396 52.3899 233.546 53.665C232.696 54.9075 231.421 55.8557 229.72 56.5096C228.02 57.1635 225.911 57.4904 223.394 57.4904C221.53 57.4904 219.928 57.3597 218.588 57.0981C217.247 56.8692 215.907 56.4769 214.566 55.921V49.8887C216.005 50.5426 217.558 51.0821 219.225 51.5071C220.893 51.9322 222.364 52.1447 223.639 52.1447C225.078 52.1447 226.091 51.9322 226.68 51.5071C227.301 51.0821 227.612 50.5263 227.612 49.8397C227.612 49.3819 227.481 48.9732 227.219 48.6136C226.99 48.2539 226.467 47.8452 225.65 47.3875C224.832 46.9297 223.557 46.3412 221.824 45.6219C220.157 44.9026 218.784 44.1997 217.705 43.513C216.626 42.7937 215.825 41.9437 215.302 40.9628C214.779 39.9492 214.517 38.6904 214.517 37.1864C214.517 34.7016 215.482 32.8379 217.411 31.5955C219.34 30.353 221.906 29.7318 225.11 29.7318C226.778 29.7318 228.364 29.8953 229.868 30.2223C231.372 30.5492 232.925 31.0887 234.527 31.8407L232.32 37.0883C231.437 36.696 230.587 36.3527 229.77 36.0584C228.952 35.7642 228.151 35.5353 227.366 35.3718C226.614 35.2083 225.83 35.1266 225.012 35.1266C223.933 35.1266 223.116 35.2737 222.56 35.568C222.037 35.8623 221.775 36.3036 221.775 36.8922C221.775 37.3172 221.906 37.7096 222.168 38.0692C222.462 38.3962 223.002 38.7558 223.786 39.1482C224.604 39.5405 225.797 40.0637 227.366 40.7176C228.903 41.3388 230.227 41.9927 231.339 42.6793C232.451 43.3332 233.301 44.167 233.889 45.1805C234.51 46.1614 234.821 47.4529 234.821 49.055ZM250.273 36.4017C250.273 37.4153 250.224 38.4289 250.126 39.4424C250.061 40.4233 249.979 41.4205 249.881 42.4341H249.979C250.306 41.9763 250.633 41.5186 250.96 41.0609C251.319 40.6031 251.679 40.1454 252.039 39.6877C252.398 39.2299 252.774 38.7885 253.167 38.3635L260.67 30.2223H268.91L258.267 41.8456L269.547 57H261.112L253.412 46.1614L250.273 48.6626V57H242.966V19.727H250.273V36.4017ZM283.138 30.2223V57H275.831V30.2223H283.138ZM279.509 19.727C280.588 19.727 281.52 19.9885 282.304 20.5117C283.089 21.0021 283.481 21.9339 283.481 23.3071C283.481 24.6476 283.089 25.5795 282.304 26.1026C281.52 26.6257 280.588 26.8873 279.509 26.8873C278.397 26.8873 277.449 26.6257 276.664 26.1026C275.912 25.5795 275.536 24.6476 275.536 23.3071C275.536 21.9339 275.912 21.0021 276.664 20.5117C277.449 19.9885 278.397 19.727 279.509 19.727Z",
    fill: "#24262D"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8_13)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 59,
    width: 13,
    height: 13,
    fill: "#A06DC0"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 15,
    width: 50,
    height: 5,
    rx: 2.5,
    fill: "#AD83C8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 24,
    width: 44,
    height: 5,
    rx: 2.5,
    fill: "#AD83C8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 33,
    width: 50,
    height: 5,
    rx: 2.5,
    fill: "#AD83C8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 42,
    width: 37,
    height: 5,
    rx: 2.5,
    fill: "#AD83C8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8_13",
    x: 52,
    y: 57,
    width: 15,
    height: 15,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_8_13"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.482849 0 0 0 0 0.333021 0 0 0 0 0.579167 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8_13"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8_13",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_13"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 287,
    height: 75,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteski);
export default __webpack_public_path__ + "static/media/Noteski.c13c8f32ca7c5d6508ff88b75af81446.svg";
export { ForwardRef as ReactComponent };